const messagesId = {
  about: 'Tentang',
  acceptanceCriteria: 'Kriteria Penerimaan',
  accomplishments: 'Pencapaian',
  actions: 'Tindakan',
  activity: 'Aktivitas',
  activatePod: 'Aktifkan POD',
  activePods: 'POD Aktif',
  add: 'Tambah',
  addBlocker: 'Tambah Informasi Blocker',
  addingCandidateWait: 'Menambahkan kandidat, harap tunggu...',
  addPortfolio: 'Tambah Portfolio',
  addStakeholder: 'Tambah Stakeholder',
  addVideoUpdate: 'Tambah Update Video',
  findAgents: 'Cari Agen',
  all: 'Semua',
  allReporters: 'Semua Reporter',
  allRepoCheckins: 'Semua Check-in Repo',
  approve: 'Setuju',
  approved: 'Disetujui',
  approvalRequests: 'Permintaan Persetujuan',
  approvedPRCount: 'Jumlah PR yang Disetujui',
  assignedItems: 'Item yang Ditugaskan',
  availability: 'Ketersediaan',
  availableDate: 'Tanggal tersedia',
  backToPods: 'Kembali ke POD Saya',
  basicInformation: 'Informasi Dasar',
  blocker: 'Blocker',
  blockerDetails: 'Detail Blocker',
  blockers: 'Blocker',
  board: 'Papan',
  browseTalent: 'Jelajahi Talenta',
  bugs: 'Bug',
  calendlyUrl: 'URL Calendly',
  cancel: 'Batal',
  candidates: 'Kandidat',
  categories: 'Kategori',
  certifications: 'Sertifikasi',
  certificationUrl: 'URL Sertifikasi',
  checkBoxBlocker: 'Centang kotak ini jika ini adalah blocker',
  ciCdPipeline: 'Pipeline CI/CD',
  clear: 'Hapus',
  client: 'Klien',
  clickHereUploadVideoClip: 'Klik di sini untuk mengunggah klip video!',
  cloudCost: 'Biaya Cloud',
  code: 'Baris Kode',
  codeSmells: 'Code Smells',
  commentHere: 'komentar di sini...',
  category: 'Kategori',
  comments: 'Komentar',
  companyName: 'Nama Perusahaan',
  copied: 'Disalin!',
  copyright: 'Hak Cipta © 2025-sekarang Brilli Global, Inc. Semua hak dilindungi.',
  copyToClipboard: 'Salin ke clipboard',
  cost: 'Biaya',
  costDetails: 'Detail Biaya',
  country: 'Negara',
  create: 'Buat',
  createArt: 'Buat ART',
  createGig: 'Buat Solusi',
  createPod: 'Buat POD',
  createProfile: 'Buat Profil',
  createProfileOpportunity: 'Buat profil Anda di database talenta kami untuk diikutsertakan dalam berbagai peluang kerja remote.',
  createTask: 'Buat Tugas',
  createYourOwnPod: 'Buat POD Anda sendiri dan jelajahi proyek',
  creatingProfile: 'Membuat profil',
  currency: 'Mata Uang',
  currentlyAvailable: 'Saat Ini Tersedia',
  currentWeek: 'Minggu Ini',
  dashboard: 'Dashboard',
  date: 'Tanggal',
  dateRangeFilter: 'Filter Rentang Tanggal',
  deactivatePod: 'Nonaktifkan POD',
  deactivateToUpdate: 'Nonaktifkan POD untuk Memperbarui POD!',
  defects: 'Cacat',
  delete: 'Hapus',
  deletePod: 'Hapus POD',
  description: 'Deskripsi',
  detailsForGitHubRepo: 'Detail untuk Repository GitHub',
  done: 'tutup',
  Done: 'SELESAI',
  doraMetrics: 'Metrik Dora',
  dueDate: 'Tanggal Jatuh Tempo',
  duplicatedLinesDensity: 'Kepadatan Baris Duplikat',
  edit: 'Edit',
  education: 'Pendidikan',
  educationAndCertifications: 'Pendidikan & Sertifikasi',
  email: 'Email',
  podTime: 'Waktu POD',
  createHub: 'Buat Hub',
  createSolution: 'Buat Solusi',
  podVelocity: 'Kecepatan POD',
  podBlockers: 'Blocker POD',
  podsync: 'Sinkronisasi POD',
  endDate: 'Tanggal berakhir',
  enterEmailToInvite: 'Masukkan Email untuk Mengundang',
  enterPodMission: 'Masukkan Misi POD',
  enterPodName: 'Masukkan Nama POD',
  enterStoryDescription: 'Masukkan Deskripsi Cerita',
  executionDate: 'Tanggal Eksekusi',
  executionID: 'ID Eksekusi',
  externalPod: 'POD Eksternal',
  fileNameNoSpaces: 'Nama file tidak boleh mengandung spasi di antara semua elemen atau karakter',
  fileUpload: 'Unggah File',
  findBestFreelancers: 'Temukan freelancer terbaik atau POD talenta untuk menyelesaikan proyek Anda dengan kecepatan yang lebih cepat!',
  findBestPod: 'Temukan POD yang sesuai dengan pengalaman/keahlian Anda',
  findPods: 'Cari POD',
  findTalent: 'Cari Talenta',
  findYourBestTalentPod: 'Temukan POD talenta terbaik Anda',
  firstName: 'Nama Depan',
  focus: 'Fokus',
  gitHubRepo: 'Repo GitHub',
  gitHubUsername: 'Username GitHub',
  github: 'Github',
  githubSummary: 'Ringkasan GitHub',
  githubUrl: 'URL Github',
  githubUser: 'Pengguna GitHub',
  giveRating: 'Berikan Rating',
  globalWorkPlatform: 'Platform Kerja Global',
  home: 'Beranda',
  hoursPerWeek: 'Jam per Minggu',
  inactivePod: 'POD Tidak Aktif',
  individual: 'Individu',
  industry: 'Industri',
  inProgress: 'SEDANG BERLANGSUNG',
  institute: 'Institut',
  internalPod: 'POD Internal',
  invite: 'Undang',
  invoices: 'Faktur',
  issueKey: 'Kunci Issue',
  issueStatus: 'Status Issue',
  issueSummary: 'Ringkasan Issue',
  jiraIssue: 'Issue Jira',
  jiraIssues: 'Issue Jira',
  jiraItem: 'Item Jira',
  jiraTimeDetails: 'Log Waktu',
  jiraUsername: 'Username Jira',
  keepDoing: 'Terus Lakukan',
  keyword: 'Kata Kunci',
  languageSpoken: 'Bahasa yang Digunakan',
  lastName: 'Nama Belakang',
  latestSprintVelocity: 'Kecepatan Sprint Terbaru',
  linkedIn: 'LinkedIn',
  linkedInUrl: 'URL LinkedIn',
  linesOfCodeByDay: 'Baris Kode per Hari',
  listOfTalents: 'Daftar Talenta',
  loading: 'Memuat',
  loadingAcceptanceCriteria: 'Memuat Kriteria Penerimaan',
  loadingStoryDescription: 'Memuat Deskripsi Cerita',
  loadingTestCases: 'Memuat Test Case',
  logOut: 'Keluar',
  login: 'Masuk',
  manage: 'Kelola',
  manageActivities: 'Kelola aktivitas POD harian dan pembaruan Anda',
  manageProfile: 'Kelola profil',
  manageProfileHere: 'Kelola profil Anda di sini',
  managePod: 'Kelola POD',
  managePods: 'Kelola semua POD dan aktivitasnya',
  markComplete: 'Tandai Selesai',
  middleName: 'Nama Tengah',
  myPods: 'POD Saya',
  myTasks: 'Tugas Saya',
  name: 'Nama',
  ncloc: 'Ncloc',
  newActivityUpdate: 'Update Aktivitas Baru',
  next: 'Berikutnya',
  noArtOptionsAvailable: 'Tidak Ada Opsi ART Tersedia',
  noBlockers: 'Tidak Ada Blocker',
  noCandidates: 'Tidak Ada Kandidat yang Ditambahkan',
  noCandidatesAddedToPod: 'Tidak Ada Kandidat yang Ditambahkan ke POD!',
  noCandidateReviews: 'Tidak ada ulasan kandidat.',
  noData: 'Tidak Ada Data',
  noDataAvailable: 'Tidak ada data tersedia',
  noExperience: 'Tidak Ada Pengalaman',
  noMatchingPods: 'Tidak ada POD yang cocok tersedia',
  noNotifications: 'Tidak ada notifikasi',
  noPodActivity: 'Anda Tidak Memiliki Aktivitas POD',
  noPods: 'Anda tidak memiliki POD',
  noPodTasks: 'Anda tidak memiliki Tugas POD',
  noReviews: 'Tidak ada ulasan.',
  noStakeholders: 'Tidak Ada stakeholder untuk POD ini',
  noSubscription: 'Anda tidak memiliki paket langganan',
  noVideoAvailable: 'Tidak ada video tersedia',
  notifications: 'Penerima Notifikasi',
  otherInformation: 'Informasi Lainnya',
  pending: 'Tertunda',
  pendingPods: 'POD Tertunda',
  phoneNumber: 'Nomor Telepon',
  pipelineExecutionDetails: 'Detail Eksekusi Pipeline',
  pipelineName: 'Nama Pipeline',
  pipelineVersion: 'Versi Pipeline',
  pleaseEnterStoryDescription: 'Silakan masukkan deskripsi cerita dan klik kirim',
  POD: 'POD',
  podActivities: 'Aktivitas POD',
  podActivity: 'Aktivitas POD',
  podAnalytics: 'Analitik POD',
  podAssist: 'Asisten POD',
  podAutomation: 'Otomasi POD',
  podBoard: 'Papan POD',
  podCategories: 'Kategori POD',
  podDescription: 'Deskripsi POD',
  podExperience: 'Pengalaman POD',
  podFeedback: 'Umpan Balik POD',
  podMetrics: 'Metrik POD',
  podName: 'Nama POD',
  podQuery: 'Query POD',
  podRequests: 'PERMINTAAN POD',
  podRetro: 'Retro POD',
  podSize: 'Ukuran POD',
  podTasks: 'Tugas POD',
  podTaskDescription: 'Deskripsi Tugas POD',
  podTaskDueDate: 'Tanggal Jatuh Tempo Tugas POD',
  podTaskName: 'Nama Tugas POD',
  podTaskOwner: 'Pemilik Tugas POD',
  podTaskStatus: 'Status Tugas POD',
  podTechStack: 'Tech Stack POD',
  podTeamMember: 'Anggota Tim POD',
  podType: 'Tipe POD',
  portfolio: 'Portfolio',
  portfolioUrl: 'URL Portfolio',
  post: 'Posting',
  postActivity: 'Posting Aktivitas',
  postPodActivity: 'Posting Aktivitas POD',
  postRequirement: 'Posting Persyaratan',
  posting: 'Memposting...',
  postedDate: 'Tanggal Posting',
  postedRequirements: 'Persyaratan POD yang Anda Posting',
  positionName: 'Nama Posisi',
  prCount: 'Jumlah PR',
  preferredWorkHours: 'Jam Kerja yang Disukai',
  prev: 'Sebelumnya',
  previousPods: 'POD Sebelumnya',
  previousWeek: 'Minggu Sebelumnya',
  primarySkill: 'Keahlian Utama',
  privacyPolicy: 'Kebijakan Privasi',
  privatePods: 'POD Pribadi',
  prSummary: 'Ringkasan PR',
  projectKey: 'Kunci Proyek',
  profileLink: 'Link Profil',
  profileVisibility: 'Visibilitas Profil',
  public: 'Publik',
  qualification: 'Kualifikasi',
  ratePerHour: 'Tarif per Jam',
  ratePerMonth: 'Tarif per Bulan',
  recentSearches: 'Pencarian Terbaru',
  region: 'Wilayah',
  register: 'Daftar',
  resetPassword: 'Reset Kata Sandi',
  restricted: 'Terbatas',
  retro: 'Retro',
  review: 'Ulasan & Rating',
  revisionSummary: 'Ringkasan Revisi',
  revisionURL: 'URL Revisi',
  resume: 'Resume',
  resumeLink: 'Lihat Resume',
  rowsPerPage: 'Baris per halaman',
  save: 'Simpan',
  search: 'Cari',
  searchProjects: 'Cari proyek',
  secondarySkill: 'Keahlian Sekunder',
  select: 'Pilih',
  selectArtName: 'Pilih Nama ART',
  selectAUser: 'Pilih Pengguna',
  selectFilter: 'Pilih Filter',
  applyFilters: 'Terapkan Filter',
  selectItemsPerPage: 'Pilih item per halaman',
  selectJiraIssues: 'Pilih Issue Jira',
  selectPod: 'Pilih POD',
  selectPodTeamMember: 'Pilih Anggota Tim POD',
  selectPods: 'Pilih POD',
  services: 'Layanan',
  setting: 'Pengaturan',
  shareableLink: 'Link yang Dapat Dibagikan',
  signUpToGetStarted: '"Daftar" di bawah untuk Memulai!',
  getStarted: 'Mulai',
  skills: 'Keahlian',
  skillsAndExpertise: 'Keahlian & Keahlian',
  sonarqubeprojectkey: 'Kunci Proyek Sonarqube',
  sonarqubeStats: 'Statistik Sonarqube',
  specialization: 'Spesialisasi',
  sprintVelocity: 'Kecepatan Sprint',
  sprint: 'Sprint',
  spotsLeft: 'Tempat Tersisa',
  startDate: 'Tanggal mulai',
  startDoing: 'Mulai Lakukan',
  status: 'Status',
  stopDoing: 'Berhenti Lakukan',
  storyDescription: 'Deskripsi Cerita',
  stories: 'Cerita',
  submit: 'Kirim',
  submittedDate: 'Tanggal Dikirim',
  submittedPRCount: 'Jumlah PR yang Dikirim',
  subscription: 'Langganan',
  talentApprovalRequests: 'Permintaan Persetujuan Talenta',
  talentCode: 'Kode Talenta',
  taskForm: 'Form Tugas',
  taskManager: 'Manajer Tugas',
  taskName: 'Nama Tugas',
  tasks: 'Tugas',
  teamMember: 'Anggota Tim',
  techStack: 'Tech Stack',
  termsOfService: 'Syarat Layanan',
  testCases: 'Test Case',
  time: 'Waktu',
  timeLog: 'Log Waktu',
  timeSubmit: 'Kirim Waktu',
  timeZone: 'Zona Waktu',
  toDo: 'YANG HARUS DILAKUKAN',
  todaysFocus: 'Fokus Hari Ini',
  totalLinesChangedLastWeek: 'Total Baris yang Diubah Minggu Lalu',
  totalLinesChangedThisWeek: 'Total Baris yang Diubah Minggu Ini',
  totalPRCount: 'Total Jumlah PR',
  university: 'Universitas',
  update: 'Perbarui',
  updateProfileHere: 'Perbarui profil Anda di sini',
  updatingVisibility: 'Memperbarui visibilitas...',
  upload: 'Unggah',
  userStory: 'User Story',
  validFrom: 'Berlaku dari',
  validTill: 'Berlaku sampai',
  talentexplorer: 'Penjelajah Talenta',
  interviewrequests: 'Permintaan Wawancara',
  videoUrl: 'URL Video',
  view: 'Lihat',
  viewActivities: 'Lihat Aktivitas',
  viewDetails: 'Lihat Detail',
  viewPodActivities: 'Lihat Aktivitas POD',
  viewPodDetails: 'Lihat Detail POD',
  viewProfile: 'Lihat Profil',
  viewTasks: 'Lihat Tugas',
  viewTimeEntries: 'Lihat Entri Waktu',
  viewVideo: 'Lihat Video',
  visitFindTalent: 'Silakan kunjungi halaman "Cari Talenta" dan tambahkan individu berbakat ke POD Anda.',
  vulnerabilities: 'Kerentanan',
  welcome: 'Selamat datang di Artemy.ai!',
  workExperience: 'Pengalaman Kerja',
  yourPod: 'POD Anda',
  yourPods: 'POD Anda',
  yourPostedPodActivity: 'Aktivitas POD yang Anda Posting',
  
  findTickets: 'Cari Tiket',
  epics: 'Epic',
  date: 'Tanggal',
  talent: 'Talenta',
  focus: 'Fokus',
  startDate: 'Tanggal Mulai',
  endDate: 'Tanggal Berakhir',
  status: 'Status',
  allStatus: 'Semua Status',
  blocked: 'Diblokir',
  onTrack: 'Sesuai Jalur',
  activityDetails: 'Detail Aktivitas',
  jiraIssues: 'Issue Jira',
  todaysFocus: 'Fokus Hari Ini',
  accomplishments: 'Pencapaian',
  blockers: 'Blocker',
  videoUpdate: 'Update Video',
  comments: 'Komentar',
  addBlockerInformation: 'Tambah Informasi Blocker',
  blockerDetails: 'Detail Blocker',
  cancel: 'Batal',
  saveChanges: 'Simpan Perubahan',
  selectJiraIssues: 'Pilih Issue Jira',
  design: 'Desain',
  development: 'Pengembangan',
  testing: 'Pengujian',
  bugFix: 'Perbaikan Bug',
  documentation: 'Dokumentasi',
  myPods: 'POD Saya',
  postRetro: 'Posting Retro',
  newRetro: 'Retro Baru',
  startDoing: 'Mulai Lakukan',
  stopDoing: 'Berhenti Lakukan',
  keepDoing: 'Terus Lakukan',
  viewRetros: 'Lihat Retro',
  podRetroFeedback: 'Umpan Balik Retro POD',
  selectSprint: 'Pilih Sprint',
  thisTaskIsBlocker: 'Tugas ini adalah blocker',
  category: 'Kategori',
  taskCreatedSuccessfully: 'Tugas berhasil dibuat!',
  taskManagement: 'Manajemen Tugas',
  searchJiraIssues: 'Cari issue JIRA...',
  creatingTask: 'Membuat Tugas...',
  createTask: 'Buat Tugas',
  description: 'Deskripsi',
  dueDate: 'Tanggal jatuh tempo',
  commentsHistory: 'Riwayat Komentar',
  noCommentsYet: 'Belum ada komentar',
  writeAComment: 'Tulis komentar...',
  all: 'Semua',
  blockerStatus: 'Status Blocker',
  blockedTasks: 'Tugas yang Diblokir',
  unblockedTasks: 'Tugas yang Tidak Diblokir',
  clearDateRange: 'Hapus Rentang Tanggal',
  selectDateRange: 'Pilih Rentang Tanggal',
  showAllTime: 'Tampilkan Semua Waktu',
  noTasksFound: 'Tidak ada tugas ditemukan',
  noLinkedIssues: 'Tidak ada issue yang terhubung',
  timeSheet: 'Lembar Waktu',
  podTimeSheet: 'Lembar Waktu POD',
  userStory: 'User Story',
  hours: 'Jam',
  minutes: 'Menit',
  actions: 'Tindakan',
  submitTimeEntries: 'Kirim Entri Waktu',
  selectCategory: 'Pilih Kategori',
  selectStory: 'Pilih Cerita',
  addRow: 'Tambah Baris',
  podSelection: 'Pemilihan POD',
  selectPodToView: 'Pilih POD untuk melihat filter sprint dan talenta',
  toDo: 'Yang Harus Dilakukan',
  podAssist: 'Asisten POD',
  inProgress: 'Sedang Berlangsung',
  done: 'Selesai',
  selectPodsRequired: 'Pilih POD (Wajib)',
  enterStoryDescription: 'Masukkan Deskripsi Cerita',
  podSyncSummaries: 'Ringkasan Sinkronisasi POD',
  enterMeetingUrl: 'Masukkan URL meeting...',
  searchInSummaries: 'Cari dalam ringkasan...',
  dateAndTime: 'Tanggal & Waktu',
  quickTimeRange: 'Rentang Waktu Cepat',
  sortByDate: 'Urutkan berdasarkan Tanggal',
  selectTalents: 'Pilih Talenta',
  filterBySpecificCandidates: 'Filter berdasarkan kandidat tertentu (opsional)',
  talentSelection: 'Pemilihan Talenta',
  priority: 'Prioritas',
  addComment: 'Tambah Komentar',
  taskDetails: 'Detail Tugas',
  summary: 'Ringkasan',
  addMeeting: 'Tambah Meeting',

  podAutomation: 'Otomasi POD',
  uploading: 'Mengunggah...',
  uploadFile: 'Unggah File',
  send: 'Kirim',
  submitting: 'Mengirim...',
  enterYourQuestionHere: 'Masukkan pertanyaan Anda di sini',
  submitTheResults: 'Kirim hasil',
  export: 'Ekspor',
  podInsights: 'Wawasan POD',
  askQuestionsAboutYourPod: 'Tanyakan tentang aktivitas POD, anggota tim, dan lainnya',
  welcomeToPodInsights: 'Selamat datang di Wawasan POD!',
  startByAskingQuestionsLike: 'Mulai dengan bertanya seperti',
  showAllPodActivitiesThatHadBlockers: 'Tampilkan semua aktivitas POD yang memiliki blocker',
  listAllCandidatesAndTheirPods: 'Daftarkan semua kandidat dan POD mereka',
  showStakeholdersFromIndia: 'Tampilkan stakeholder dari India',
  askAnythingAboutYourPods: 'Tanya apa saja tentang POD, anggota tim, aktivitas...',
  sending: 'Mengirim...',
  analyzingYourQuestion: 'Menganalisis pertanyaan Anda...',
  pipelineCICD: 'Pipeline CI/CD',
  tickets: 'Tiket',
  metricName: 'Nama Metrik',
  metricValue: 'Nilai Metrik',
  commentsHistory: 'Riwayat Komentar',
  noCommentsYet: 'Belum ada komentar',
  writeAComment: 'Tulis komentar...',
  solutionManagement: 'Manajemen Solusi',
  searchSolutions: 'Cari Solusi...',
  refresh: 'Segarkan',
  createNewSolution: 'Buat Solusi Baru',
  solutionName: 'Nama Solusi',
  solutionDescription: 'Deskripsi Solusi',
  updateSolution: 'Perbarui Solusi',
  createSolution: 'Buat Solusi',
  confirmSolutionDeletion: 'Apakah Anda yakin ingin menghapus Solusi',
  artManagement: 'Manajemen ART',
  podManagement: 'Manajemen POD',
  searchPods: 'Cari POD...',
  viewPod: 'Lihat POD',
  searchARTs: 'Cari ART...',
  noARTsFound: 'Tidak ditemukan ART. Buat ART pertama Anda dengan mengklik tombol "Buat ART Baru".',
  createNewART: 'Buat ART Baru',
  selectGig: 'Pilih Gig',
  artName: 'Nama ART',
  artDescription: 'Deskripsi ART',
  createART: 'Buat ART',
  confirmDeletion: 'Konfirmasi Penghapusan',
  confirmARTDeletion: 'Apakah Anda yakin ingin menghapus ART',
  primaryLanguage: 'Bahasa Utama',
  selectSkills: 'Pilih Keahlian',
  timeZone: 'Zona Waktu',
  updateART: 'Perbarui ART',
  somethingWentWrong: 'Ada yang salah',
  reloadPage: 'Muat Ulang Halaman',
  privatePods: 'POD Pribadi',
  activePods: 'POD Aktif',
  completedPods: 'POD Selesai',
  pendingPods: 'POD Tertunda',
  loadingPods: 'Memuat POD...',
  retry: 'Coba Lagi',
  noPodsFound: 'Tidak ditemukan POD',
  createFirstPod: 'Buat POD pertama Anda untuk memulai',
  previous: 'Sebelumnya',
  showing: 'Menampilkan',
  size: 'Ukuran',
  teamSize: 'Ukuran Tim',
  activeMembers: 'Anggota Aktif',
  stakeholders: 'Stakeholder',
  podManagers: 'Manajer POD',
  addManager: 'Tambah Manajer',
  podManager: 'Manajer POD',
  noManagersAssignedYet: 'Belum ada manajer yang ditugaskan',
  addManagersToHelpOversee: 'Tambah manajer untuk membantu mengawasi POD ini',
  noStakeholdersYet: 'Belum ada stakeholder',
  settings: 'Pengaturan',
  deletePod: 'Hapus POD',
  addPodManager: 'Tambah Manajer POD',
  selectManagerToInvite: 'Pilih manajer untuk diundang ke POD ini:',
  noManagersAvailableToInvite: 'Tidak ada manajer yang tersedia untuk diundang.',
  selectAManager: 'Pilih manajer',
  selectedManager: 'Manajer Terpilih',
  inviteManager: 'Undang Manajer',
  noTeamMembersYet: 'Belum ada anggota tim',
  startByInvitingMembers: 'Mulai dengan mengundang anggota ke POD Anda',
  inviteTeamMembers: 'Undang Anggota Tim',
  existingMembers: 'Anggota yang Ada',
  inviteByEmail: 'Undang melalui Email',
  searchByNameOrSkills: 'Cari berdasarkan nama atau keahlian...',
  optionalSelectUserToNotify: 'Opsional: Pilih pengguna untuk diberi tahu melalui Slack',
  pleaseSelectPodToEnableFields: 'Silakan pilih POD untuk mengaktifkan field lain',
  selectedCandidates: 'Kandidat Terpilih',
  selectCandidatesToInvite: 'Pilih kandidat untuk diundang ke POD ini',
  availableCandidates: 'Kandidat Tersedia',
  inviteNewMembersByEmail: 'Undang Anggota Baru melalui Email',
  emailAddresses: 'Alamat Email',
  enterEmailAddresses: 'Masukkan alamat email (dipisahkan dengan koma)',
  hidePodTeamMembers: 'Sembunyikan anggota tim POD ini di bagian Cari POD (Saat Ini Terlihat)',
  technicalDetails: 'Detail Teknis',
  currentTeamSize: 'Ukuran tim saat ini',
  communicationDetails: 'Detail Komunikasi',
  podReview: 'Ulasan POD',
  rating: 'Rating',
  writeReview: 'Tulis Ulasan',
  shareYourExperience: 'Bagikan pengalaman Anda dengan POD ini...',
  submitReview: 'Kirim Ulasan',
  viewPod: 'Lihat POD',
  managePod: 'Kelola POD',
  editPod: 'Edit POD',
  skillsAndExperience: 'Keahlian & Pengalaman',
  reviews: 'Ulasan',
  documents: 'Dokumen',
  otherInfo: 'Info Lainnya',
  noWorkExperienceDataAvailable: 'Tidak ada data pengalaman kerja tersedia',
  selectART: 'Pilih ART',
  selectAnART: 'Pilih ART',
  jiraConfiguration: 'Konfigurasi Jira',
  jiraProjectKey: 'Kunci Proyek Jira',
  jiraURL: 'URL Jira',
  jiraAdminEmail: 'Email Admin Jira',
  jiraAdminAPIToken: 'Token API Admin Jira',
  jiraOpenStoryBugStatus: 'Status Story/Bug Terbuka Jira',
  jiraClosedStoryBugStatus: 'Status Story/Bug Tertutup Jira',
  gitHubConfiguration: 'Konfigurasi GitHub',
  gitHubUsername: 'Username GitHub',
  gitHubAPIToken: 'Token API GitHub',
  gitHubRepositoryName: 'Nama Repository GitHub',
  circleCIConfiguration: 'Konfigurasi CircleCI',
  circleCIGitHubUsername: 'Username GitHub CircleCI',
  circleCIGitHubRepository: 'Repository GitHub CircleCI',
  circleCIAPIToken: 'Token API CircleCI',
  sonarQubeConfiguration: 'Konfigurasi SonarQube',
  sonarQubeCloudURL: 'URL SonarQube Cloud',
  sonarQubeAPIToken: 'Token API SonarQube',
  awsConfiguration: 'Konfigurasi AWS',
  awsAccessKeyID: 'ID Kunci Akses AWS',
  awsSecretAccessKey: 'Kunci Akses Rahasia AWS',
  awsRegion: 'Wilayah AWS',
  bitBucketConfiguration: 'Konfigurasi BitBucket',
  bitBucketUsername: 'Username BitBucket',
  bitBucketAppPassword: 'Password Aplikasi BitBucket',
  bitBucketWorkspace: 'Workspace BitBucket',
  openAIConfiguration: 'Konfigurasi OpenAI',
  openAIToken: 'Token OpenAI',
  storyPointsCalculation: 'Perhitungan Story Points',
  uploadStoryPointsCalculationFile: 'Unggah File Perhitungan Story Points',
  currentFile: 'File saat ini',
  notifications: 'Notifikasi',
  markAllAsRead: 'Tandai semua sebagai dibaca',
  tryAgain: 'Coba Lagi',
  noNotificationsToDisplay: 'Tidak ada notifikasi untuk ditampilkan',
  viewAllNotifications: 'Lihat Semua Notifikasi',
  enterMultipleEmailsSeparatedByCommas: 'Masukkan beberapa email yang dipisahkan dengan koma',
  addEmailAddressesToInvite: 'Tambahkan alamat email untuk mengundang anggota baru',
  emailInvitationGuidelines: 'Panduan Undangan Email',
  inviteesWillReceiveInstructions: 'Yang diundang akan menerima instruksi untuk bergabung dengan POD ini',
  theyWillNeedToCreateAccount: 'Mereka perlu membuat akun jika belum memilikinya',
  noCandidatesAvailable: 'Tidak ada kandidat tersedia',
  sendEmailInvites: 'Kirim Undangan Email',

  processingDataAndGeneratingInsights: 'Memproses data dan menghasilkan wawasan',
  retroHistory: 'Riwayat Retro',
  filterByMember: 'Filter Berdasarkan Anggota',
  podProductivity: 'Produktivitas POD',
  totalTasks: 'Total Tugas',
  completed: 'Selesai',
  clearFilters: 'Hapus Filter',
  totalActivities: 'Total Aktivitas',
  pendingApproval: 'Menunggu Persetujuan',
  sortBy: 'Urutkan Berdasarkan',
  editSolution: 'Edit Solusi',
  cannotDeleteAssociatedWithARTs: 'Tidak dapat dihapus - terkait dengan ART',
  editART: 'Edit ART',
  createdDate: 'Tanggal Dibuat',
  podDetails: 'Detail POD',
  currentARTProject: 'ART/Proyek Saat Ini',
  artProject: 'ART/Proyek',
  selectAvailability: 'Pilih Ketersediaan',
  selectSkill: 'Pilih Keahlian',
  selectTimezone: 'Pilih Zona Waktu',
  selectLocation: 'Pilih Lokasi',
  selectBudget: 'Pilih Anggaran',
  podMember: 'Anggota POD',
  addToPod: 'Tambah ke POD',
  talentDetails: 'Detail Talenta',
  reviewsFeedback: 'Ulasan & Umpan Balik',
  noEducationDataAvailable: 'Tidak ada data pendidikan tersedia',
  noCertificationDataAvailable: 'Tidak ada data sertifikasi tersedia',
  clientReview: 'Ulasan Klien',
  noReviewsAvailableYet: 'Belum ada ulasan tersedia',
  noClientReviews: 'Talenta ini belum menerima ulasan klien sejauh ini',
  resumeAvailable: 'Resume Tersedia',
  viewDownloadResume: 'Lihat atau unduh resume kandidat',
  noResumeAvailable: 'Tidak Ada Resume Tersedia',
  noResumeUploaded: 'Talenta ini belum mengunggah resume.',
  codingAssessment: 'Penilaian Coding',
  assessmentAvailable: 'Penilaian Tersedia',
  viewAssessmentResults: 'Lihat hasil penilaian coding kandidat',
  noAssessmentAvailable: 'Tidak Ada Penilaian Tersedia',
  noAssessmentCompleted: 'Talenta ini belum menyelesaikan penilaian coding.',
  partnerCompanyDetails: 'Detail Perusahaan Mitra',
  companyIntroductionVideo: 'Video Pengenalan Perusahaan',
  videoNotSupported: 'Browser Anda tidak mendukung tag video.',
  location: 'Lokasi',
  noPodsMatchingCriteria: 'Tidak ditemukan POD yang sesuai dengan kriteria Anda',
  hirePod: 'Sewa POD',
  notificationHistory: 'Riwayat Notifikasi',
  filter: 'Filter',
  allNotifications: 'Semua Notifikasi',
  markSelected: 'Tandai Terpilih',
  unread: 'Belum dibaca',
  noNotificationsFound: 'Tidak ada notifikasi ditemukan',
  searchNotifications: 'Cari notifikasi...',
  subscriptionManagement: 'Manajemen Berlangganan',
  choosePlanPrompt: 'Pilih paket yang paling sesuai dengan kebutuhan Anda dan berkembang seiring pertumbuhan Anda',
  cancelSubscription: 'Batalkan Berlangganan',
  choosePlan: 'Pilih Paket',
  noPlansAvailable: 'Tidak Ada Paket Tersedia',
  noPlansHelpText: 'Silakan periksa kembali nanti atau hubungi dukungan untuk bantuan.',
  currentPlanDetails: 'Detail Paket Saat Ini',
  renewalDate: 'Tanggal Pembaruan',
  subscriptionId: 'ID Berlangganan',
  paymentMethod: 'Metode Pembayaran',
  cardHolder: 'Pemegang Kartu',
  expires: 'Berakhir',
  brand: 'Merek',
  billingHistory: 'Riwayat Penagihan',
  noInvoiceHistory: 'Tidak ada riwayat faktur tersedia',
  needHelp: 'Butuh Bantuan?',
  supportText: 'Jika Anda memiliki pertanyaan tentang paket berlangganan kami atau memerlukan bantuan, tim dukungan kami siap membantu Anda.',
  contactSupport: 'Hubungi Dukungan',
  completeSubscription: 'Selesaikan Berlangganan Anda',
  planDetails: 'Detail Paket',
  planName: 'Nama Paket',
  basePrice: 'Harga Dasar',
  numberOfUsers: 'Jumlah Pengguna',
  billingCycle: 'Siklus Penagihan',
  orderSummary: 'Ringkasan Pesanan',
  annualDiscount: 'Diskon Tahunan',
  billingPeriod: 'Periode Penagihan',
  tax: 'Pajak',
  totalWithTax: 'Total dengan Pajak',
  annually: 'tahunan',
  continue: 'Lanjutkan',
  subscriptionSuccessful: 'Berlangganan Berhasil!',
  thankYouSubscribing: 'Terima kasih telah berlangganan',
  subscriptionActivated: 'Berlangganan Anda telah berhasil diaktifkan.',
  goToDashboard: 'Pergi ke Dashboard',
  addPaymentMethod: 'Tambah Metode Pembayaran',
  cardNumber: 'Nomor Kartu',
  cardholderName: 'Nama Pemegang Kartu',
  expiryMonth: 'Bulan Berakhir',
  expiryYear: 'Tahun Berakhir',
  postalCode: 'Kode Pos',
  addCard: 'Tambah Kartu',
  paymentChoice: 'Gunakan Kartu yang Ada atau Tambah Kartu Baru',
  existingCardText: 'Anda sudah memiliki kartu yang berakhir dengan',
  useExistingCardPrompt: 'Apakah Anda ingin menggunakannya untuk berlangganan ini?',
  useExistingCard: 'Gunakan Kartu yang Ada',
  addNewCard: 'Tambah Kartu Baru',
  processing: 'Memproses...',
  subscriptionSuccessDetails: 'berhasil!',
  accessAllFeatures: 'Sekarang Anda dapat mengakses semua fitur yang termasuk dalam paket berlangganan Anda.',
  editCardDetails: 'Edit Detail Kartu',
  managerInvite: 'Undangan Manajer',
  talentInvite: 'Undangan Talenta',
  invitePodManagers: 'Masukkan E-Mail untuk Mengundang Manajer Pod',
  enterEmail: 'Masukkan E-Mail',
  invite: 'Undang',
  yourInvoices: 'Faktur Anda',
  noInvoices: 'Anda tidak memiliki faktur.',
  amountDue: 'Jumlah yang Harus Dibayar',
  getCountIsseswithNoCritria: 'Dapatkan jumlah masalah tanpa kriteria penerimaan',
  amountPaid: 'Jumlah yang Dibayar',
  noActiveSubscription: 'Anda tidak memiliki paket berlangganan aktif. Silakan klik tautan "Berlangganan" untuk menambah berlangganan.',
noActiveSubscriptionStart: 'Anda tidak memiliki paket berlangganan aktif. Silakan klik',
  subscribe: 'Berlangganan',
  noActiveSubscriptionEnd: 'tautan untuk menambah berlangganan.'};

export default messagesId;